import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type UserId = string;

export interface Account {
    id: number | null;
    title: string | null;
    main: boolean;
}

export interface UserProvider {
    id: number | null;
    source: string;
}

export interface UserDetail {
    accounts: Account[];
    createdAt: string;
    disabled: boolean;
    email: string;
    employerId: number | null;
    hhid: number | null;
    id: number | null;
    lastActivityTime: string;
    name: string;
    personalManagerEmail: string;
    personalManagerId: number | null;
    useHHManager: boolean;
    providers?: UserProvider[];
}

// ----------------------- actions -------------------------------------
const SET_USER_USER_DETAIL = 'SET_USER_USER_DETAIL';
const SET_USER_ID_USER_DETAIL = 'SET_USER_ID_USER_DETAIL';

interface PayloadTypes {
    [SET_USER_USER_DETAIL]: UserDetail;
    [SET_USER_ID_USER_DETAIL]: UserId;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setUser = ActionCreator(SET_USER_USER_DETAIL);
export const setUserId = ActionCreator(SET_USER_ID_USER_DETAIL);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface UserDetailState {
    user: UserDetail;
    userId: UserId;
}

export const USER_DETAIL_INITIAL_STATE: UserDetailState = {
    user: {
        accounts: [],
        createdAt: '',
        disabled: false,
        email: '',
        employerId: null,
        hhid: null,
        id: null,
        lastActivityTime: '',
        name: '',
        personalManagerEmail: '',
        personalManagerId: null,
        useHHManager: false,
    },
    userId: '',
};

export default createReducer<UserDetailState, PayloadTypes>(USER_DETAIL_INITIAL_STATE, {
    [SET_USER_USER_DETAIL]: (state, { payload }) => ({
        ...state,
        user: payload,
    }),
    [SET_USER_ID_USER_DETAIL]: (state, { payload }) => ({
        ...state,
        userId: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
